import React, { Component } from "react";
import AjaxPost from "../../components/AjaxPost/AjaxPost";
import ThankYou from "../../components/ThankYou/ThankYou";
import Captcha2026 from "../../components/Captcha2026/Captcha2026";
import GA from "../../components/GA/GA";
import "./Contacts.css";

class Contacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      website: "", // honeypot field — real users never fill this
      humanCheck: false,
      formOK: false,
      showThankYou: false,
      apiTimestamp: null,
      apiTimestampLoaded: null,
    };
  }

  componentDidMount(props) {
    this.props.changePage("contacts");
    GA("Page: Contacts");

    fetch("/api/ts")
      .then((response) => response.json())
      .then((data) => this.setState({ apiTimestampLoaded: data.ts }))
      .catch(() => this.setState({ apiTimestampLoaded: null }));

    fetch("copy.json")
      .then((response) => response.json())
      .then((copy) => this.setState({ copy }));
  }

  checkFormFields = () => {
    let state = this.state;
    if (
      state.name !== "" &&
      state.email !== "" &&
      state.subject !== "" &&
      state.message !== "" &&
      state.humanCheck === true
    ) {
      state.formOK = true;
    } else {
      state.formOK = false;
    }
    this.setState(state);
  };

  setValue = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    this.checkFormFields();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let that = this;
    let formData = new FormData();

    formData.append("name", this.state.name);
    formData.append("email", this.state.email);
    formData.append("subject", this.state.subject);
    formData.append("message", this.state.message);
    formData.append("website", this.state.website);
    formData.append("ats", this.state.apiTimestamp);

    AjaxPost("/api/contacts", formData, function (e) {
      //console.dir( e )
      // that.clearFormValues()
      that.showThankYouMessage();
      GA("Form Submit: Contacts");
    });
  };

  showThankYouMessage = (e) => {
    let state = {
      showThankYou: true,
    };
    this.setState(state);
  };

  clearFormValues = (e) => {
    let cleanState = {
      name: "",
      email: "",
      subject: "",
      message: "",
      formOK: false,
    };
    this.setState(cleanState);
  };

  closeThankYou = (e) => {
    let state = this.state;
    state.showThankYou = false;
    this.setState(state);
  };

  handleCaptchaActivated = (e) => {
    let state = this.state;
    state.humanCheck = true;
    state.apiTimestamp = state.apiTimestampLoaded;
    this.setState(state);
    this.checkFormFields();
  }

  render() {
    return (
      <div className="page-container">
        <div className="content-spacer-1 spacer-bg-contacts"></div>

        <div className="content-container">
          <div className="content-container-background"></div>

          <div className="content-container-content">
            <h1>Contacts</h1>
            <br />
            We strive to present you with the best cleaning and customer services in London.
            <br />
            <br />
            Simply choose one of the easy ways to contact us, that suits you the most.
            <br />
            <br />
            <strong>Contact us</strong>
            <p>
              E-mail: <a href={`mailto:${this.state.copy?.email || ""}`}>{this.state.copy?.email || ""}</a>
            </p>
            <p>Telephone: {this.state.copy?.phone_with_spaces || ""}</p>
            <br />
            <form onSubmit={this.handleSubmit}>
              <span className="form-label">
                Name <span className="red">*</span>
              </span>
              <br />
              <input
                type="text"
                name="name"
                value={this.state.name}
                onChange={this.setValue}
                placeholder="Name"
                className="form-input contacts-name"
              />
              <br />
              <br />

              <span className="form-label">
                Email <span className="red">*</span>
              </span>
              <br />
              <input
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.setValue}
                placeholder="Email"
                className="form-input contacts-email"
              />
              <br />
              <br />

              <span className="form-label">
                Subject <span className="red">*</span>
              </span>
              <br />
              <input
                type="text"
                name="subject"
                value={this.state.subject}
                onChange={this.setValue}
                placeholder="Subject"
                className="form-input contacts-subject"
              />
              <br />
              <br />

              <span className="form-label">
                Message <span className="red">*</span>
              </span>
              <br />
              <textarea
                name="message"
                value={this.state.message}
                onChange={this.setValue}
                className="form-input form-textarea"
              ></textarea>
              <br />
              <br />

              <input
                type="text"
                name="website"
                value={this.state.website}
                onChange={this.setValue}
                autoComplete="off"
                className="form-input form-input-2"
              />

              <Captcha2026 onActivate={this.handleCaptchaActivated}/>

              <div className={this.state.formOK ? "form-info-hidden" : "form-info"}>
                Please fill in all form fields.
              </div>

              <button disabled={!this.state.formOK} className="form-input form-button">
                Submit
              </button>
            </form>
            <div className={this.state.showThankYou ? "fixed100" : "hidden"}>
              <ThankYou onClick={() => this.closeThankYou()} />
            </div>
            <br />
            <br />
            <div className="cleaning-tips-container">
              <div className="cleaning-tip-icon"></div>
              <i>
                Stains on white clothes of blood, wine, coffee can be easily removed if you soak the stained area in
                vinegar and after put in to normal wash! Spot off!
              </i>
              <div className="breaker"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contacts;
